<zbp-modal-template
  [bodyContent]="modalBody"
  [footerContentFull]="modalFooter"
>
</zbp-modal-template>
<ng-template #modalBody>
  <div class="modal-body">
    <span id="message" [innerHtml]=params.body></span>
  </div>
</ng-template>
<ng-template #modalFooter id="modal-footer">
  <div class="modal-footer">
    <zbp-button-component id="closeButton"
                          type="button"
                          [label]="params.confirm.label"
                          ariaLabel="Close"
                          theme="primary"
                          [fullWidth]="true"
                          [topBottomPaddingSpacingS]="true"
                          (clickHandler)="closeModal()"
    ></zbp-button-component>
  </div>
</ng-template>
